var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgressBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.310752,0,0,7.14286,-21.6905,-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.8,
    y: 28,
    width: 321.7,
    height: 14,
    style: {
      fill: "rgb(204,204,204)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.310752,0,0,7.14286,-21.6905,-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.1,
    y: 28,
    width: 2.1,
    height: 14,
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.310752,0,0,7.14286,-21.6905,-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.7,
    y: 28,
    width: 2.6,
    height: 14,
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.310752,0,0,7.14286,-21.6905,-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.2,
    y: 28,
    width: 3.2,
    height: 14,
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.310752,0,0,7.14286,-21.6905,-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.6,
    y: 28,
    width: 4.1,
    height: 14,
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.310752,0,0,7.14286,-21.6905,-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.9,
    y: 28,
    width: 5.1,
    height: 14,
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.310752,0,0,7.14286,-21.6905,-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.2,
    y: 28,
    width: 6.4,
    height: 14,
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.310752,0,0,7.14286,-21.6905,-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.2,
    y: 28,
    width: 8,
    height: 14,
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.310752,0,0,7.14286,-21.6905,-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 28,
    width: 9.9,
    height: 14,
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.310752,0,0,7.14286,-21.6905,-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.6,
    y: 28,
    width: 12.5,
    height: 14,
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.310752,0,0,7.14286,-21.6905,-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 28,
    width: 15.5,
    height: 14,
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.310752,0,0,7.14286,-21.6905,-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.1,
    y: 28,
    width: 19.3,
    height: 14,
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.310752,0,0,7.14286,-21.6905,-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.8,
    y: 28,
    width: 63.8,
    height: 14,
    style: {
      fill: "rgb(26,26,26)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBar);
export default __webpack_public_path__ + "static/media/progressBar.8190c879.svg";
export { ForwardRef as ReactComponent };